/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Call activity for a single client/agent surface (e.g. claude-code, cursor, codex) calling an unproxied MCP server
 */
export type UnproxiedMcpServerClientUsageRow = {
  /**
   * Number of observed calls from this client
   */
  callCount: number;
  /**
   * The hook-reported client/agent surface
   */
  client: string;
};

/** @internal */
export const UnproxiedMcpServerClientUsageRow$inboundSchema: z.ZodMiniType<
  UnproxiedMcpServerClientUsageRow,
  unknown
> = z.pipe(
  z.object({
    call_count: z.int(),
    client: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "call_count": "callCount",
    });
  }),
);

export function unproxiedMcpServerClientUsageRowFromJSON(
  jsonString: string,
): SafeParseResult<UnproxiedMcpServerClientUsageRow, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UnproxiedMcpServerClientUsageRow$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UnproxiedMcpServerClientUsageRow' from JSON`,
  );
}
